import React from 'react';
import clsx from 'clsx';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';

import { SELECTED_MEDIA_UPLOAD_ACCEPT } from '../../constants/uploadAccept';

import scss from './SelectedMediaHeroDropzone.module.scss';

function SelectedMediaHeroDropzone({ onUpload, children, disabled = false }) {
  const { t } = useTranslation('story');

  const { getRootProps, getInputProps, isDragAccept, isDragReject } = useDropzone({
    accept: SELECTED_MEDIA_UPLOAD_ACCEPT,
    multiple: true,
    noClick: true,
    noKeyboard: true,
    disabled,
    onDrop: (files) => {
      if (files.length) {
        onUpload(files);
      }
    },
  });

  return (
    <div
      {...getRootProps({
        className: clsx(scss.zone, isDragAccept && scss.accept, isDragReject && scss.reject),
      })}>
      <input {...getInputProps()} />
      {children}

      {isDragAccept || isDragReject ? (
        <div className={scss.overlay} aria-hidden='true'>
          <FileUploadOutlinedIcon className={scss.overlayIcon} />
          <span className={scss.overlayText}>{isDragReject ? t('dropMediaInvalid') : t('dropMediaRelease')}</span>
        </div>
      ) : null}
    </div>
  );
}

export default SelectedMediaHeroDropzone;
